import { createAction } from "@reduxjs/toolkit";
import type {
  RaiseComplaintRequest,
  ComplaintStatusRequest,
  ApiEnvelope,
  RaiseComplaintResponsePayload,
  ComplaintStatusResponsePayload,
  ApiErrorPayload,
  DispositionItem,
} from "./bbpsComplaintTypes";

// raise complaint
export const raiseComplaintRequest = createAction<RaiseComplaintRequest>(
  "bbpsComplaint/raiseComplaintRequest",
);
export const raiseComplaintSuccess = createAction<
  ApiEnvelope<RaiseComplaintResponsePayload>
>("bbpsComplaint/raiseComplaintSuccess");
export const raiseComplaintFailure = createAction<ApiErrorPayload>(
  "bbpsComplaint/raiseComplaintFailure",
);
export const raiseComplaintReset = createAction(
  "bbpsComplaint/raiseComplaintReset",
);

// complaint status
export const complaintStatusRequest = createAction<ComplaintStatusRequest>(
  "bbpsComplaint/complaintStatusRequest",
);
export const complaintStatusSuccess = createAction<
  ApiEnvelope<ComplaintStatusResponsePayload>
>("bbpsComplaint/complaintStatusSuccess");
export const complaintStatusFailure = createAction<ApiErrorPayload>(
  "bbpsComplaint/complaintStatusFailure",
);
export const complaintStatusReset = createAction(
  "bbpsComplaint/complaintStatusReset",
);

// dispositions
export const fetchDispositionsRequest = createAction(
  "bbpsComplaint/dispositions/request",
);
// export const fetchDispositionsRequest = createAction<{ force?: boolean }>(
//   "bbpsComplaint/dispositions/request"
// );

export const fetchDispositionsSuccess = createAction<{
  items: DispositionItem[];
  message?: string;
}>("bbpsComplaint/dispositions/success");

export const fetchDispositionsFailure = createAction<{
  message: string;
  statusCode?: number;
}>("bbpsComplaint/dispositions/failure");

export const fetchDispositionsReset = createAction(
  "bbpsComplaint/dispositions/reset",
);
